module.exports = __webpack_public_path__ + "img/FAR1_600x495.736e72e1.jpg";